module.exports = __webpack_public_path__ + "static/img/icon_yuki.ef35d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_yuki.png
// module id = 381
// module chunks = 1